import React from "react"
import CustomButton from "../../../../../ui/atoms/Button"
import { Basket } from "../../../state/checkoutTypes"
import OrderRecapItem from "./OrderRecapItem"

interface Props {
  basket: Basket
}

const OrderRecapItems = ({ basket }: Props) => {
  const [viewAll, setViewAll] = React.useState(false)
  const items = (viewAll ? basket?.items : basket?.items.slice(0, 4)) ?? []
  return (
    <>
      {items.map((x, index) => (
        <OrderRecapItem item={x} key={index} />
      ))}
      {basket.giftItems?.map((x, index) => (
        <OrderRecapItem item={x} key={index} priceOverride="OMAGGIO" />
      ))}
      {basket?.items.length > 4 && (
        <div className="text-center">
          <CustomButton variant="text" onClick={() => setViewAll(!viewAll)}>
            {viewAll ? "Vedi meno" : "Vedi tutti"}
          </CustomButton>
        </div>
      )}
    </>
  )
}

export default OrderRecapItems
